import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Dropdown from '../../Components/utils/ReuseDropdown';
import { FaEye } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../Components/utils/Loader';

const API = process.env.REACT_APP_Backend_Host_Name;

function AdminDisputes() {
  const [disputes, setDisputes] = useState([]);
  const [filterType, setFilterType] = useState('All');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDisputes = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem('adminToken');
        const params = filterType !== 'All' ? { status: filterType } : {};
        const response = await axios.get(`${API}/api/v1/admins/disputes/all`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        });
        if (response.data.success) {
          setDisputes(response.data.disputes || []);
        }
      } catch (err) {
        console.error('Error fetching disputes:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDisputes();
  }, [filterType]);

  const filterOptions = ['All', 'negotiating', 'admin_involved', 'resolved'];
  const displayFilter = filterType === 'All' ? 'All' : filterType.replace('_', ' ');

  return (
    <div className="adminOrdersDiv adminDisputesPage">
      <div className="adminOrdersContent">
        <div className="tableDiv">
          <div className="tableContent">
            <div className="upper">
              <h2 className="secondaryHeading">
                <span>{displayFilter} </span>Disputes
                <span className="totalRows">- {disputes.length}</span>
              </h2>
              <div className="upperRight">
                <Dropdown
                  options={filterOptions}
                  selected={filterType}
                  onSelect={setFilterType}
                />
              </div>
            </div>
            <div className="header">
              <p className="title">Order</p>
              <p>Buyer</p>
              <p>Seller</p>
              <p>Amount</p>
              <p>Status</p>
              <p>Started By</p>
              <p>Actions</p>
            </div>
            <div className="rows">
              {isLoading ? (
                <Loader type="simpleMini" />
              ) : disputes.length > 0 ? (
                disputes.map((item, index) => {
                  const order = item.orderId;
                  const buyer = order?.buyerId;
                  const seller = order?.sellerId;
                  return (
                    <div key={item._id}>
                      <div className="requestRow row">
                        <div className="titleField field">
                          <p className="title">#{order?.customOrderId || 'N/A'}</p>
                        </div>
                        <p className="buyerField field">{buyer?.username || 'N/A'}</p>
                        <Link to={`/vendorDetail/${seller?._id}`} className="sellerField field">
                          {seller?.userId?.username || seller?.displayName || 'N/A'} &gt;
                        </Link>
                        <p className="priceField field">${order?.summary?.total?.toFixed(2) || '0.00'}</p>
                        <p className="statusField field">{item.status}</p>
                        <p className="field">{item.initiatedBy === 'buyer' ? 'Buyer' : 'Seller'}</p>
                        <div className="actionsField field">
                          <FaEye
                            className="icon"
                            onClick={() => navigate(`/chwi-admin/disputes/${item._id}`)}
                            title="Manage"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="row">Nothing to show here...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDisputes;
